import React, { forwardRef, ForwardRefExoticComponent } from 'react';

import { Error } from '../error';
import { Field } from '../field';
import type { FieldProps } from '../field/field';
import { Hint } from '../hint';

const COMPONENT_ID = 'modulor-text-field';

export const TextField: ForwardRefExoticComponent<FieldProps> = forwardRef<
  HTMLDivElement,
  FieldProps
>(
  (
    {
      label,
      value,
      maxLength,
      minLength,
      pattern,
      readOnly = false,
      placeholder,
      error,
      disabled = false,
      icon,
      iconPlaceholder,
      inputMode,
      onChange,
      onActionIconClick,
      onFocus,
      onBlur,
      onKeyUp,
      onKeyDown,
      placeholderMask,
      isRequired,
      clearVisible,
      dataTestId = COMPONENT_ID,
      className,
      hint,
      ...rest
    },
    ref,
  ) => {
    return (
      <>
        <Field
          ref={ref}
          label={label}
          value={value}
          placeholder={placeholder}
          icon={icon}
          iconPlaceholder={iconPlaceholder}
          onChange={onChange}
          error={!disabled && error}
          disabled={disabled}
          onActionIconClick={onActionIconClick}
          readOnly={readOnly}
          pattern={pattern}
          minLength={minLength}
          maxLength={maxLength}
          inputMode={inputMode}
          placeholderMask={placeholderMask}
          type="text"
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          isRequired={isRequired}
          clearVisible={clearVisible}
          dataTestId={`${dataTestId}-field`}
          className={className}
          {...rest}
        />
        {!disabled && typeof error === 'string' ? (
          <Error error={error} dataTestId={`${dataTestId}-error`} />
        ) : null}
        {hint && !error ? <Hint hint={hint} dataTestId={`${dataTestId}-hint`} /> : null}
      </>
    );
  },
);

TextField.displayName = 'TextField';
